"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MathHelper = /** @class */ (function () {
    function MathHelper() {
    }
    MathHelper.roundNumber = function (numberToRound, numberOfDecimalPlaces) {
        if (numberToRound === 0) {
            return 0;
        }
        if (!numberToRound) {
            return '';
        }
        var scrubbedNumber = numberToRound.toString().replace('$', '').replace(',', '');
        return Math.round(scrubbedNumber * Math.pow(10, numberOfDecimalPlaces)) / Math.pow(10, numberOfDecimalPlaces);
    };
    MathHelper.percentDifference = function (num1, num2) {
        if (num1 == 0 && num2 == 0) {
            return 0;
        }
        var ref = Math.max(Math.abs(num1), Math.abs(num2));
        var diff = num2 - num1;
        return Math.abs(diff) / ref;
    };
    return MathHelper;
}());
exports.default = MathHelper;
//# sourceMappingURL=mathHelper.js.map


/** WEBPACK FOOTER **
 ** ./src/utils/mathHelper.js
 **/